<div (mouseout)="restoreLastHoveredElement()" class="w-full pb-3" style="height: 510px;">
  <p-skeleton *ngIf="!svgLoaded" height="100%"></p-skeleton>
  <div #baseContainer id="base" class="h-full" [ngStyle]="svgLoaded ? {'z-index': 'auto'} : {'z-index': '-1'} "></div>
</div>

